export { viewHelpCentersManagementPageRoute } from './routes';
